













import { defineComponent, computed } from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';
import getHandicraftTypesForSelector from '@/gql/getHandicraftTypesForSelector.gql';

const CommonHandicraftTypeSelector = defineComponent({
  setup(props: any) {
    /* ==== Define handicraft type ==== */
    const { result: handicraftTypeResult, loading } = useQuery(getHandicraftTypesForSelector);
    const handicraftType = useResult(handicraftTypeResult, null, (data) => data.handicraftTypes);
    const computedHandicraftTypeId = computed(() => {
      if (!handicraftType.value) return [undefined];
      const temp: string[] = [];
      handicraftType.value.forEach((item: any) => {
        temp.push(item.id);
      });
      return temp;
    });
    const computedHandicraftTypeName = computed(() => {
      if (!handicraftType.value) return [undefined];
      const temp: string[] = [];
      handicraftType.value.forEach((item: any) => {
        temp.push(item.name);
      });
      return temp;
    });
    const computedHandicraftTypeCode = computed(() => {
      const temp: string[] = [];
      if (!handicraftType.value) return [undefined];
      handicraftType.value.forEach((item: any) => {
        temp.push(`${item.code} - ${item.name}`);
      });
      return temp;
    });

    const _value = computed(() => props.value);

    return {
      loading,
      computedHandicraftTypeId,
      computedHandicraftTypeDisplay: props.displayCode ? computedHandicraftTypeCode : computedHandicraftTypeName,
      _value,
    };
  },
  props: {
    label: {
      type: String,
      default() { return 'ประเภทชิ้นงาน'; },
    },
    value: {
      type: String,
      default() { return ''; },
    },
    displayCode: {
      type: Boolean,
      default() { return false; },
    },
  },
});

export default CommonHandicraftTypeSelector;
